// extracted by mini-css-extract-plugin
export var center = "SimpleCard-module--center--bbf5e";
export var container = "SimpleCard-module--container--c3331";
export var content = "SimpleCard-module--content--fd803";
export var full = "SimpleCard-module--full--5896c";
export var icon = "SimpleCard-module--icon--b6386";
export var short = "SimpleCard-module--short--34234";